import './account';
import './dashboards';
import './calendar';
import './users';
import './alert';
import './attendance';
import './complaints';
import './trips';
import './d2dwasteCollected';
import './dumpyardPresence';
import './vehicleDisconnected';
import './dumpyardMismatch';
import './vehicleOperation';
import './vehicleUsage';
import './vehicleTimeline';
import './fuelConsumption';
import './slaCompliance';
import './routeViolation';
import './vehicleTampering';
import './driverChange';
import './driverPerformance';
import './geofenceInOut';
import './jobData';
import './vehicleAllocation';
import './vehicleLoginLogOff';
